import { uploadSingleFile, uploadFilesGetLinks } from "../files";
import { API, authClient } from "../index";

// Get all actice customers
export const getAllActiveCustomers = (role) => {
  return authClient().get(`${API}/customer/?role=${role}`);
};

// Get all customers
export const getAllCustomers = (role) => {
  return authClient().get(`${API}/customer/?getDisabled=true&role=${role}`);
};

// Get customer by id
export const getCustomerById = (id) => {
  return authClient().get(`${API}/customer/${id}`);
};

// Create customer
export const postCustomer = async (customer, logo, documents) => {
  if (logo) {
    const response = await uploadSingleFile(logo, "logos");
    customer.logoURL = response?.data?.fileURL;
  }

  if (documents?.length > 0) {
    const response = await uploadFilesGetLinks(documents, "documents");
    customer.documents = response;
  }
  return authClient().post(`${API}/customer/`, customer);
};

// Update text
export const updateCustomer = async (
  id,
  customer,
  logo,
  resultTmpDescription
) => {
  if (logo) {
    const response = await uploadSingleFile(logo, `logos/${id}`);
    customer.logoURL = response?.data?.fileURL;
  }

  return authClient().put(
    `${API}/customer/${id}?result=${resultTmpDescription}&&bckoff=true`,
    customer
  );
};

// Change status technology
export const changeStatusCustomer = async (id, active) => {
  return authClient().put(`${API}/customer/change-status/${id}`, { active });
};

// Delete customer
export const deleteCustomer = (id) => {
  return authClient().delete(`${API}/customer/${id}`);
};

export const signUpCustomer = async (customer) => {
  return authClient().post(`${API}/customer/signup`, customer);
};
